import { render, staticRenderFns } from "./aDisplayOptionsContainer.vue?vue&type=template&id=d23b60e6&scoped=true"
var script = {}
import style0 from "./aDisplayOptionsContainer.vue?vue&type=style&index=0&id=d23b60e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23b60e6",
  null
  
)

export default component.exports